const ACTIONS = ["view", "add", "edit", "delete"];
const ACTION_INDEX_MAP = {
  0: "view",
  1: "add",
  2: "edit",
  3: "delete",
};

const cleanKey = (value = "") =>
  String(value).toLowerCase().replace(/\s+/g, "").replace(/[^a-z]/g, "");

const hasAction = (perms, action) => {
  const wanted = cleanKey(action);

  if (Array.isArray(perms)) {
    return perms.some((item) => {
      const normalized = ACTION_INDEX_MAP[String(item).trim().toLowerCase()] || cleanKey(item);
      return normalized === wanted;
    });
  }

  if (perms && typeof perms === "object") {
    return perms[wanted] === true;
  }

  return false;
};

export function canView(user, moduleKey) {
  if (!user) return false;

  const role = (user.role || "").toLowerCase();
  if (role === "superadmin" || role === "manager") return true;
  if (!user.permissions) return false;

  const perms = user.permissions[cleanKey(moduleKey)];
  return hasAction(perms, "view");
}

export function canDo(user, moduleKey, action) {
  if (!user) return false;

  const role = (user.role || "").toLowerCase();
  if (role === "superadmin" || role === "manager") return true;
  if (!user.permissions) return false;

  const perms = user.permissions[cleanKey(moduleKey)];
  return hasAction(perms, action);
}
